module.exports = __webpack_public_path__ + "img/img2.e9d30214.png";